import React, { useState } from 'react';
import { DialogInput, RequiredDialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import SiteOrBusinessUnitSelect from '../SiteOrBusinessUnitSelect';
import { useSaveAffectedArea, useDeleteAffectedArea } from '../../../../hooks/useAffectedAreas';

function AffectedAreaEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {
    const [fieldErrors, setFieldErrors] = useState({});
    const { saveAffectedArea } = useSaveAffectedArea();
    const { deleteFunction } = useDeleteAffectedArea(dialogData);

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    };

    return (
        <CommonConfigDialog title={"Affected Area - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveAffectedArea} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formAffectedAreaName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <SiteOrBusinessUnitSelect controlIdPrefix="AffectedArea" dialogData={dialogData} setDialogData={setDialogData} fieldErrors={fieldErrors} />
            <DialogInput controlId="formAffectedAreaDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formAffectedAreaTranslationKey" title="Translation Key" placeholder="Translation.Key" name="translationKey" value={dialogData.translationKey} error={fieldErrors.translationKey} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default AffectedAreaEditDialog;